<template>
  <div class="maintainService">
    <div>
      <el-form
        class="formStyle"
        label-width="80px"
        label-position="left"
        :rules="rules"
        ref="form"
        :model="formData">
        <el-form-item label="您的姓名" prop="name">
          <el-input size="small" clearable v-model="formData.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input size="small" clearable v-model="formData.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="connectionWay">
          <el-input size="small" clearable v-model="formData.connectionWay" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="需求描述" prop="reqDesc">
          <el-input size="small" type="textarea" clearable v-model="formData.reqDesc" placeholder="请输入需求描述"></el-input>
        </el-form-item>
        <div align="center">
          <el-button size="mini" type="info" @click="submitInfo">提交</el-button>
          <el-button size="mini" type="info" @click="reset">重置</el-button>
        </div>
      </el-form>
    </div>
    <div style="margin-top: 50px">
      <img src="../../assets/wx.png" alt="">
    </div>
  </div>
</template>
<script>
  import {
    saveMaintainService
  } from "@/api/hoaccu";
  export default{
    name:"maintainService",
    data(){
      return{
        formData:{
          companyName:"",
          connectionWay:"",
          name:"",
          reqDesc:""
        },
        rules:{
          companyName:[
            {required:true,message:"请输入公司名称",trigger:"blur"}
          ],
          connectionWay:[
            {required:true,message:"请输入联系方式",trigger:"blur"}
          ],
          name:[
            {required:true,message:"请输入您的姓名",trigger:"blur"}
          ],
          reqDesc:[
            {required:true,message:"请输入需求描述",trigger:"blur"}
          ],
        }
      }
    },
    created(){

    },
    methods:{
      submitInfo(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
            saveMaintainService(this.formData).then(res=>{
              if (res.status === 200) {
                this.$message.success("提交成功！");
                this.reset();
              } else {
                this.$message.warning(res.message);
              }
            }).catch(err=>{
              this.$message.warning(err.message);
            })
          } else {
            return false;
          }
        });
      },
      reset(){
        Object.keys(this.formData).forEach(item=>this.formData[item] = "");
        this.$refs["form"].resetFields();
      }
    },
  }
</script>
<style lang="less" scoped>
  .maintainService{
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    .info{
      margin-bottom: 20px;
      &>div{
        line-height: 25px;
        font-size: 14px;
        color: #666;
      }
      .title{
        color: red;
        font-weight: bold;
      }
    }

    .formStyle{
      border: 1px solid #ccc;
      width: 500px;
      padding: 20px;
      border-radius: 5px;
      background: rgba(255,255,255,.8);
      /deep/.el-input,/deep/.el-textarea{
        width: 300px;
      }
    }
  }
</style>
